import { render, staticRenderFns } from "./brandpage.vue?vue&type=template&id=b87ba3c8"
import script from "./brandpage.vue?vue&type=script&lang=js"
export * from "./brandpage.vue?vue&type=script&lang=js"
import style0 from "./brandpage.vue?vue&type=style&index=0&id=b87ba3c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports